import { render, staticRenderFns } from "./CustomPagization.vue?vue&type=template&id=3ba8d66d&scoped=true"
import script from "./CustomPagization.vue?vue&type=script&lang=js"
export * from "./CustomPagization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8d66d",
  null
  
)

export default component.exports